import type {DeserializeComponentParams} from '../types'
import {updateComponentScopedValues} from './scopedValues'
import {DATA_TYPES} from '../../../../constants/constants'

export const updateComponentLayoutStructure = (deserializationParams: DeserializeComponentParams) => {
    const {createExtArgs, compStructure, pageId, mappers} = deserializationParams
    updateComponentScopedValues(createExtArgs, compStructure, DATA_TYPES.layout, pageId, mappers)
}
